export { default as GroupSalesMultiSlot } from './GroupSalesMultiSlot';
